/**
 * Normalizzazione deterministica del testo prodotto dalla Web Speech API.
 *
 * Il browser restituisce testo grezzo: non interpreta "virgola" o "punto"
 * e può separare una frase in più risultati. Questa funzione non riscrive il
 * contenuto: applica soltanto i comandi di dettatura italiani e gli spazi
 * necessari attorno alla punteggiatura.
 */
const DICTATION_COMMANDS: Array<[RegExp, string]> = [
  [/\bnuovo\s+paragrafo\b/gi, "\n\n"],
  [/\ba\s+capo\b/gi, "\n"],
  [/\bpunto\s+e\s+virgola\b/gi, ";"],
  [/\bpunto\s+interrogativo\b/gi, "?"],
  [/\bpunto\s+esclamativo\b/gi, "!"],
  [/\bdue\s+punti\b/gi, ":"],
  [/\bvirgola\b/gi, ","],
  [/\bpunto\b/gi, "."],
];

export function normalizeItalianDictation(value: string): string {
  let normalized = value.replace(/\u00a0/g, " ");

  for (const [pattern, replacement] of DICTATION_COMMANDS) {
    normalized = normalized.replace(pattern, replacement);
  }

  return normalized
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n[ \t]+/g, "\n")
    .replace(/[ \t]+([,.;:!?])/g, "$1")
    .replace(/([,.;:!?])(?=[^\s\]\)}»”])/g, "$1 ")
    .replace(/[ \t]{2,}/g, " ")
    .trim();
}

/** Unisce i risultati finali/interim senza incollare parole o punteggiatura. */
export function appendItalianDictation(existing: string, next: string): string {
  const previous = normalizeItalianDictation(existing);
  const incoming = normalizeItalianDictation(next);

  if (!previous) return incoming;
  if (!incoming) return previous;
  if (previous.endsWith("\n") || /^[,.;:!?\]\)}»”]/.test(incoming)) {
    return normalizeItalianDictation(`${previous}${incoming}`);
  }
  if (/[\[\({«“]$/.test(previous)) {
    return normalizeItalianDictation(`${previous}${incoming}`);
  }
  return normalizeItalianDictation(`${previous} ${incoming}`);
}
